import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <h1>Subi</h1>
    </div>
  );
}

export default App;
